var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("q-table", {
    ref: "table",
    staticClass: "q-mt-lg",
    attrs: {
      data: _vm.data,
      columns: _vm.columns,
      "row-key": "id",
      pagination: _vm.server_pagination,
      loading: _vm.loading,
      "no-data-label": _vm.$t("no_data_avaliable"),
      "no-results-label": _vm.$t("no_results_found"),
      "loading-label": _vm.$t("loading_data"),
      "rows-per-page-label": _vm.$t("items_per_page"),
      "rows-per-page-options": [5, 10, 50, 100],
      "binary-state-sort": ""
    },
    on: {
      "update:pagination": function($event) {
        _vm.server_pagination = $event
      },
      request: _vm.request
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function(props) {
          return _c(
            "q-tr",
            { attrs: { props: props } },
            _vm._l(props.cols, function(col) {
              return _c("q-th", { key: col.name, attrs: { props: props } }, [
                _vm._v("\n        " + _vm._s(_vm.$t(col.label)) + "\n        ")
              ])
            }),
            1
          )
        }
      },
      {
        key: "body",
        fn: function(props) {
          return [
            _c(
              "q-tr",
              { attrs: { props: props } },
              [
                _c("q-td", { key: "webcast_title", attrs: { props: props } }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(props.row.webcast_title) +
                      "\n            "
                  )
                ]),
                _c(
                  "q-td",
                  { key: "webcast_test_title", attrs: { props: props } },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(props.row.webcast_test_title) +
                        "\n            "
                    )
                  ]
                ),
                _c(
                  "q-td",
                  { key: "webcast_test_type_id", attrs: { props: props } },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$t(
                            _vm.getTestType(props.row.webcast_test_type_id)
                          )
                        ) +
                        "\n            "
                    )
                  ]
                ),
                _c("q-td", { key: "qty_questions", attrs: { props: props } }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(props.row.qty_questions) +
                      "\n            "
                  )
                ]),
                _c("q-td", { key: "score", attrs: { props: props } }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        props.row.score ? props.row.score.toFixed(2) : ""
                      ) +
                      "\n            "
                  )
                ]),
                _c("q-td", { key: "percent", attrs: { props: props } }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        props.row.percent
                          ? props.row.percent.toFixed(2) + "%"
                          : ""
                      ) +
                      "\n            "
                  )
                ]),
                _c("q-td", { key: "test_score", attrs: { props: props } }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        props.row.test_score
                          ? props.row.test_score.toFixed(2)
                          : ""
                      ) +
                      "\n            "
                  )
                ]),
                _c("q-td", { key: "result_date", attrs: { props: props } }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.getDateFormated(props.row.result_date)) +
                      "\n            "
                  )
                ]),
                _c(
                  "q-td",
                  { key: "status", attrs: { props: props } },
                  [
                    _c(
                      "q-chip",
                      {
                        staticClass: "full-width",
                        attrs: {
                          small: "",
                          icon: _vm.getIconStatus(props.row.status),
                          color: _vm.getColorStatus(props.row.status)
                        }
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$t(_vm.getStatus(props.row.status))) +
                            "\n                "
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }